<div *ngIf="loading$ | async" class="overlay">
  <p-progressSpinner></p-progressSpinner>
</div>